<template>
  <BaseNew
    @new-confirm-action="createEntry"
    @new-cancel-action="resetForm"
    @new-open-action="loadServerEntry"
    @clear-form-errors="clearFormErrors"
    ref="baseNew"
    width="80%"
    :formErrors="formErrors"
    :loading="loading"
    :pageLoading="pageLoading"
    :modelNameSingular="modelNameSingular"
  >
    <template slot="newForm">
      <Form
        ref="form"
        :entry="entry"
        :extraData="extraData"
        :modelNameSingular="modelNameSingular"
      />
    </template>
  </BaseNew>
</template>

<script>
import gql from 'graphql-tag';
import Form from "./form.vue";
import BaseNew from "@shared_components/base_new.vue";

export default {
  data() {
    return {
      error: null,
      loading: true,
      pageLoading: false,
      entry: null,
      formErrors: [],
      extraData: null,
    };
  },
  props: {
    modelNameSingular: String,
    saleOrderIds: [],
  },
  components: {
    Form: Form,
    BaseNew: BaseNew
  },
  methods: {
    loadServerEntry: function() {
      this.error = null;
      this.loading = true;
      this.$apollo
        .query({
          query: LOAD_NEW_SALE_ORDER_QUERY,
          variables: {
            saleOrderIds: this.saleOrderIds,
          },
          fetchPolicy: "no-cache"
        })
        .then(response => {
          this.entry = response.data.accountContext.saleOrder;
          this.extraData = response.data;
        })
        .catch(response => console.log(response))
        .finally(() => (this.loading = false));
    },
    createServerEntry: function(saleOrder) {
      // console.log("saleOrder", saleOrder, saleOrder.validations, this.deepFilterEntryWithAllowedFieldsForMutation(saleOrder, saleOrder.validations));
      this.pageLoading = true;
      saleOrder.saleOrderIds = this.saleOrderIds;
      // console.log("antes filter", saleOrder);
      var filterSaleOrder =  this.deepFilterEntryWithAllowedFieldsForMutation(saleOrder, saleOrder.validations);
      // console.log("filter", filterSaleOrder);
      this.$apollo
        .mutate({
          mutation: CREATE_SALE_ORDER_MUTATION,
          variables: {
            input: filterSaleOrder,
          }
        })
        .then(response => {
          var errors = response.data.createSaleOrder.errors

          if (errors.length){
            this.formErrors = errors
          } else {
            this.$refs.baseNew.closeDialog();
            this.$emit("entry-created");
            this.resetForm();
          }
        })
        .catch(error => {
          let { graphQLErrors, networkError, response, operation } = error;
          console.log("error", error)
          console.log("caiu no catch");
          console.log(graphQLErrors);
          console.log(networkError);
          console.log(response);
          console.log(operation);
          if (networkError){
            console.log(`[Network error]: ${networkError}`);
          }
          else if (graphQLErrors){
            graphQLErrors.map(({ message, locations, path }) =>
              console.log(
                `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`
              )
            );
          }
        })
        .finally(() => (this.pageLoading = false));
    },
    createEntry: function() {
      if (this.$refs.form.isFormValid()){
        this.createServerEntry(this.entry);
      }
    },
    resetForm: function() {
      if (this.$refs.form) {
        this.$refs.form.resetFormInputs();
      }
      this.formErrors = [];
    },
    clearFormErrors: function() {
      this.formErrors = [];
    }
  }
};

const LOAD_NEW_SALE_ORDER_QUERY = gql `
  query ($saleOrderIds: [ID!]) {
    accountContext {
      saleOrder(saleOrderIds: $saleOrderIds) {
        id
        code
        plate
        date
        saleOrderTime
        billDate
        estimatedDeliveryDate
        fiscalDocumentType
        orderValidity
        customerId
        totalPrice
        observation
        validations
        carrierId
        carrier {
          id
        }
        carriageModalityId
        carriageModality {
          id
        }
        carrierPatrimonyId
        carrierPatrimony {
          id
        }
        carrierLicensePlate
        carrierLicensePlateStateId
        totalCarriageValue
        totalDiscountValue
        totalInsuranceValue
        otherExpensesTotalValue
        dummyExitMovementItemsAttributes {
          id
          price
          quantity
          packagingQuantity
          itemId
          storageId
          packagingId
          isNewItemInStorage
          unitPrice
          packagingUnitName
          packagingPrice
          packaging{
            id
            name
            size
            text
          }
          item {
            id
            name
            description
            unit {
              name
            }
          }
          storage {
            id
            name
          }
        }
        paymentsAttributes {
          id
          code
          bankAccountId
          paymentMethodId
          value
          initialDate
          installmentsIntervalId
          installmentsInterval {
            id
            description
          }
          paymentConditionId
          paymentCondition {
            id
            description
            numberOfInstallments
          }
          paymentMethod {
            id
            name
          }
          bankAccount {
            id
            name
          }
          installmentsAttributes {
            id
            value            
            originalValue
            customCode
            dueDate
            code            
            status
            statusKey            
            statusColor
            paidAmount
            paymentDate
            bankAccount {
              id
              name
            }
          }
        }
      }
      allPaymentConditionRules{
        id
        name
      }
      allCustomers {
        id
        name
        tablePriceId
      }
      allCarriers {
        id
        name
      }
      allCfops{
        id
        text
      }
      accountPermissions{
        isAltavenda
        isSeller
      }
    }
    globalContext {
			allPaymentConditions {
        id
        description
        numberOfInstallments
      }
      allCarriageModalities {
        id
        text
      }
      allStates {
        id
        shortName
      }
    }
  }
`;

const CREATE_SALE_ORDER_MUTATION = gql `
  mutation($input: SaleOrderCreateInputObject!) {
    createSaleOrder(input: $input) {
      cashFlow {
        id
      }
      errors
    }
  }
`;

</script>

<style scoped></style>

<!--
mutation {
  createSale(
    customerId: 3,
    deliveryDate: "2020-01-31",
    saleProductsAttributes: [
      {price: 100, quantity: 10, itemId: 14, storehouseId: 3}
    ],
    paymentsAttributes: [
      {value: 1000, numberOfInstallments: 1, initialDate:"2020-01-31", bankAccountId: 1, paymentMethodId: 16}
    ]
  ){
    cashFlow {
      id
    }
    errors
  }
}
 -->
